var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('p',[_vm._v("Copyright © 2025 伟晟达技术开发        "),_c('span',{staticClass:"beian",staticStyle:{"color":"blue"},on:{"click":_vm.beian}},[_vm._v("备案号：辽ICP备2025048399号-1")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }